module.exports = __webpack_public_path__ + "static/media/membership.05f4fff4.svg";